// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file yatayat/types/v1/types.proto (package yatayat.types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yatayat/types/v1/types.proto.
 */
export const file_yatayat_types_v1_types: GenFile = /*@__PURE__*/
  fileDesc("Chx5YXRheWF0L3R5cGVzL3YxL3R5cGVzLnByb3RvEhB5YXRheWF0LnR5cGVzLnYxIicKDUxvY2FsaXplZE5hbWUSCgoCZW4YASABKAkSCgoCbmUYAiABKAkiFgoFTW9uZXkSDQoFcGFpc2EYASABKAMqgwEKDFZlaGljbGVDbGFzcxIdChlWRUhJQ0xFX0NMQVNTX1VOU1BFQ0lGSUVEEAASGgoWVkVISUNMRV9DTEFTU19PUkRJTkFSWRABEhgKFFZFSElDTEVfQ0xBU1NfREVMVVhFEAISHgoaVkVISUNMRV9DTEFTU19TVVBFUl9ERUxVWEUQA0LKAQoUY29tLnlhdGF5YXQudHlwZXMudjFCClR5cGVzUHJvdG9QAVpEZ2l0aHViLmNvbS9hYmRoZXNobmF5YWsveWF0YXlhdC9iYWNrZW5kL2dlbi95YXRheWF0L3R5cGVzL3YxO3R5cGVzdjGiAgNZVFiqAhBZYXRheWF0LlR5cGVzLlYxygIQWWF0YXlhdFxUeXBlc1xWMeICHFlhdGF5YXRcVHlwZXNcVjFcR1BCTWV0YWRhdGHqAhJZYXRheWF0OjpUeXBlczo6VjFiBnByb3RvMw");

/**
 * LocalizedName carries a name in English and Nepali.
 *
 * @generated from message yatayat.types.v1.LocalizedName
 */
export type LocalizedName = Message<"yatayat.types.v1.LocalizedName"> & {
  /**
   * @generated from field: string en = 1;
   */
  en: string;

  /**
   * @generated from field: string ne = 2;
   */
  ne: string;
};

/**
 * Describes the message yatayat.types.v1.LocalizedName.
 * Use `create(LocalizedNameSchema)` to create a new message.
 */
export const LocalizedNameSchema: GenMessage<LocalizedName> = /*@__PURE__*/
  messageDesc(file_yatayat_types_v1_types, 0);

/**
 * Money is an amount in Nepali rupees, held in paisa (1 NPR = 100 paisa).
 *
 * @generated from message yatayat.types.v1.Money
 */
export type Money = Message<"yatayat.types.v1.Money"> & {
  /**
   * @generated from field: int64 paisa = 1;
   */
  paisa: bigint;
};

/**
 * Describes the message yatayat.types.v1.Money.
 * Use `create(MoneySchema)` to create a new message.
 */
export const MoneySchema: GenMessage<Money> = /*@__PURE__*/
  messageDesc(file_yatayat_types_v1_types, 1);

/**
 * VehicleClass is the comfort class that sets the fare multiplier.
 *
 * @generated from enum yatayat.types.v1.VehicleClass
 */
export enum VehicleClass {
  /**
   * @generated from enum value: VEHICLE_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VEHICLE_CLASS_ORDINARY = 1;
   */
  ORDINARY = 1,

  /**
   * @generated from enum value: VEHICLE_CLASS_DELUXE = 2;
   */
  DELUXE = 2,

  /**
   * @generated from enum value: VEHICLE_CLASS_SUPER_DELUXE = 3;
   */
  SUPER_DELUXE = 3,
}

/**
 * Describes the enum yatayat.types.v1.VehicleClass.
 */
export const VehicleClassSchema: GenEnum<VehicleClass> = /*@__PURE__*/
  enumDesc(file_yatayat_types_v1_types, 0);

